import React from "react";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from "src/components/ui/sheet";
import { PropertyListingForm } from "./PropertyListingForm";
import {
  useCreatePropertyListing,
  useUpdatePropertyListing,
} from "../hooks/usePropertyListings";
import { useToast } from "src/components/ui/toast";

export function PropertyListingDrawer({
  open,
  onClose,
  listing,
  onSuccess,
  isRental = false,
}) {
  const isEdit = !!listing;
  const { toast } = useToast();

  const createHook = useCreatePropertyListing();
  const updateHook = useUpdatePropertyListing();

  const isPending = createHook.isPending || updateHook.isPending;

  async function handleSubmit(data) {
    const { __images, ...fields } = data;
    const photos = {
      files: __images?.newFiles || [],
      removeIds: __images?.removedIds || [],
    };
    const payload = Object.fromEntries(
      Object.entries(fields).filter(
        ([, v]) => v !== "" && v !== null && v !== undefined
      )
    );

    try {
      if (isEdit) {
        await updateHook.mutate(listing.id, payload, photos);
        toast({ title: "Listing updated", description: listing.title });
      } else {
        await createHook.mutate(payload, photos);
        toast({ title: "Listing created", description: payload.title });
      }
      onSuccess?.();
      onClose();
    } catch (errors) {
      const msg = Array.isArray(errors)
        ? errors[0]
        : errors?.message || "Something went wrong";
      toast({ variant: "destructive", title: "Error", description: msg });
    }
  }

  return (
    <Sheet open={open} onOpenChange={(v) => !v && onClose()}>
      <SheetContent side="right" className="flex flex-col p-0 sm:max-w-[480px]">
        <SheetHeader>
          <SheetTitle>
            {isEdit
              ? "Edit Listing"
              : isRental
              ? "New Rental Listing"
              : "New Sale Listing"}
          </SheetTitle>
          <SheetDescription>
            {isEdit
              ? "Update the property details below."
              : "Fill in the details to create a new property listing."}
          </SheetDescription>
        </SheetHeader>

        <PropertyListingForm
          listing={listing}
          onSubmit={handleSubmit}
          onCancel={onClose}
          isPending={isPending}
          isRental={isRental}
        />
      </SheetContent>
    </Sheet>
  );
}
